import { SmartComponent } from "smart-component-js";
import Swiper, { Navigation, Pagination } from "swiper";

class GenericSwiperComponent extends SmartComponent {
  constructor(element, parentComponent, params) {
    super(element, parentComponent, params);
    this.element = element;
    this.swiper = this.element.parentElement;
    this.slidesPerView = this.element.dataset.slideNumber ? parseInt(this.element.dataset.slideNumber) : 1;
    this.init();
  }

  addSwiperStructure() {
    this.swiper.classList.add('swiper', 'generic-swiper');
    this.element.classList.add('swiper-wrapper');
    const slides = this.swiper.querySelectorAll('.swiper-wrapper > .yxpRow');
    slides.forEach((slide) => slide.classList.add('swiper-slide'));

    this.swiper.insertAdjacentHTML('afterend', `
        <div class="generic-swiper-navigation-container">
            <div class="swiper-button-prev">
                <icontemplate icon="chevron-right" size="xlarge" clazz="icon"></icontemplate>
            </div>
            <div class="swiper-button-next">
                <icontemplate icon="chevron-right" size="xlarge" clazz="icon"></icontemplate>
            </div>
        </div>
    `);

    this.swiper.insertAdjacentHTML('beforeend', `<div class="swiper-pagination"></div>`);
    window.iconManager.processIconAsync(this.swiper.parentElement);
  }

  initSwiper() {
    const swiperWrapper = this.swiper.parentElement;
    new Swiper(this.swiper, {
      slidesPerView: this.slidesPerView > 1 ? 1.2 : 1,
      spaceBetween: 20,
      breakpoints: {
        768: {
          slidesPerView: Math.ceil(this.slidesPerView / 2)
        },
        1024: {
          slidesPerView: this.slidesPerView
        }
      },
      modules: [Navigation, Pagination],
      pagination: {
        el: swiperWrapper.querySelector('.swiper-pagination'),
        clickable: true,
        type: 'bullets'
      },
      navigation: {
        nextEl: swiperWrapper.querySelector('.swiper-button-next'),
        prevEl: swiperWrapper.querySelector('.swiper-button-prev')
      }
    });
  }


  init() {
    this.addSwiperStructure();
    this.initSwiper();
  }
}

export default GenericSwiperComponent;
